<template>
  <NuxtLink
    :to="$localePath(`/`)"
    class="link flex flex-col justify-center items-center p-2 relative"
  >
    <div class="flex justify-center">
      <HomeLinkIcon :class="['inactive', { 'hidden': isActive }]" />
      <HomeLinkActiveIcon :class="['active', { 'block': isActive, 'hidden': !isActive }]" />
    </div>
    <div
      class="text-xs pt-0.5 text-center md:text-xxs"
      :class="{ 'text-black font-medium': isActive }"
    >
      Главная
    </div>
  </NuxtLink>
</template>

<script>
import HomeLinkActiveIcon from '~/assets/svg/header/home-active.svg?component'
import HomeLinkIcon from '~/assets/svg/header/home.svg?component'
export default {
  components: {
    HomeLinkIcon,
    HomeLinkActiveIcon,
  },
  computed: {
    isActive () {
      return this.$route.name?.includes('index__')
    },
  },
}
</script>
